<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.buyer_detail" placeholder="手机号码" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="100">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="buyerDetail" label="客户信息" width="500"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click="recordOpen(scope.row.buyerPhone)" type="text" size="small">客户购买记录</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="客户购买记录" :visible.sync="recordDialog" width="80%" :close-on-click-modal="false">
            <LogMemoListComponent :phone="phone" ref="LogMemoListView"></LogMemoListComponent>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

import LogMemoListComponent from "../LogMemo/LogMemoListComponent.vue"

export default {
    components: {
        LogMemoListComponent
    },
    mixins: [verifyMixin, listMixin, imageMixin, enumMixin],
    data: function () {
        return {
            recordDialog: false,
            phone: ""
        }
    },
    methods: {
        recordOpen: function (phone) {
            this.phone = phone;
            this.recordDialog = true;
        }
    },
    created: async function () {
        this.tag = "BUYER";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>